var map = {
	"./forest-mobile.mp4": "dNdw",
	"./forest.mp4": "1lpW",
	"./ocean-mobile.mp4": "Qoyf",
	"./ocean.mp4": "GAET"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gsEv";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.mp4$
// module id = gsEv
// module chunks = 1